<template>
  <div>
    <h1>Email Sent... We will be with you shortly</h1>
    <router-link tag="a" to="/">Go home</router-link>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
div {
  padding: 100px;
  max-width: 100%;
  background-color: #f2f2f2;
  min-height: calc(100vh - 50px);
}
h1 {
  padding: 20px;
}
a {
  padding: 10px;
  background-color: #2c3e50;
  outline: none;
  color: white;
  text-decoration: none;
}
a:hover {
  color: silver;
}
</style>
